export const http = {
    OK: 200,
    Unauthorized: 401,
};
